import TwpRefinebarController from './TwpRefineBarController';
import twpRefineBarTemplate from './refinebar.html';

function directive() {
  return {
    restrict: 'AE',
    scope: {
      filterSet: '=',
      searchType: '@'
    },
    template: twpRefineBarTemplate,
    controller: 'TwpRefinebarController'
  };
}

export default function (ngModule) {
  ngModule.directive('twpRefinebar', directive);
  TwpRefinebarController(ngModule);
}
